import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AOS from "aos";
import "aos/dist/aos.css";
import NavigationBar from "../component/NavigationBar";
import Footer from "../component/Footer";

function Layout() {
  const location = useLocation();

  // Init AOS once, then refresh on every route change so animations
  // re-trigger on mobile after navigation.
  useEffect(() => {
    AOS.init({
      duration: 600,
      once: true,
      easing: "ease-out",
      offset: 60,
      disable: false,
    });
  }, []);

  useEffect(() => {
    AOS.refresh();
  }, [location.pathname]);

  return (
    <div className="flex flex-col">
      <ToastContainer position="bottom-right" />
      <NavigationBar />
      <div className="flex flex-col flex-grow w-full pt-16">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

export default Layout;
